import { setStore, getStore, removeStore } from "@/utils/localStorage";
import {constantRoutes, asyncRoutes} from '../router.js';
import deepCopy from '@/utils/deepCopy';

const state = {
  isGenerateRoutes: getStore('isGenerateRoutes') || true,  //是否从写路由
  isInspectVersion: '',  //是否检查版本号
  routes: [],
  _ENTRANCETYPE: getStore("_ENTRANCETYPE") || '',  //入口 成教/自考/学位申报
  adultType: getStore("adultType") || '',  //成教 adultJCE:专科
  
  // 登录相关 
  enterConfirm: getStore('enterConfirm') || 0,  //确认信息 0未确认 1已确认
  firstLoginVerify: getStore('firstLoginVerify') || 0,   //是否第一次登录 控制上传身份证/e签宝
  enterSchoolImgCheck: getStore('enterSchoolImgCheck') || 0,   //入学照审核状态
  enterSchoolImg: getStore('enterSchoolImg') || '',   //入学照
  userInfo: getStore('userInfo') || '',  //用户信息
  signImg: getStore('signImg') || '',   //手写签名
};

const mutations = {
  SET_adultType(state, v){
    state.adultType = v;
    setStore("adultType", v);
  },
  signImgMutation(state, payload) {
    state.signImg = payload;
    setStore("signImg", payload);
  },
  enterSchoolImgMutation(state, payload) {
    state.enterSchoolImg = payload;
    setStore("enterSchoolImg", payload);
  },
  enterSchoolImgCheckMutation(state, payload) {
    state.enterSchoolImgCheck = payload;
    setStore("enterSchoolImgCheck", payload);
  },
  SET_isInspectVersion: (state, v) => {
    state.isInspectVersion = v;
  },
  userInfoMutation(state, payload) {
    state.userInfo = payload;
    setStore("userInfo", payload);
  },
  enterConfirmMutation(state, payload) {
    state.enterConfirm = payload;
    setStore("enterConfirm", payload);
  },
  firstLoginVerifyMutation(state, payload) {
    state.firstLoginVerify = payload;
    setStore("firstLoginVerify", payload);
  },
  SET_isGenerateRoutes: (state, v) => {
    if(v === '' || v === null){
        state.isGenerateRoutes = true;
      // localStorage.removeItem('isGenerateRoutes');
      removeStore('isGenerateRoutes');
    }else{
      state.isGenerateRoutes = v;
      // localStorage.setItem('isGenerateRoutes', v);
      setStore('isGenerateRoutes', v);
    }
  },
  SET_ROUTES: (state, v) => {
    state.routes = v;
    // if(v === [] || v === '' || v === null){
    //   // localStorage.removeItem('routes');
    //   removeStore('routes');
    // }else{
    //   console.log(v);
    //   state.routes = v;
    //   // localStorage.setItem('routes', JSON.stringify(v));
    //   setStore('routes', JSON.stringify(v));
    // }
  },
  SET_ENTRANCETYPE(state, v) {
    if(v === '' || v === null){
      // localStorage.removeItem('_ENTRANCETYPE');
      removeStore('_ENTRANCETYPE');
    }else{
      state._ENTRANCETYPE = v;
      // localStorage.setItem('_ENTRANCETYPE', v);
      setStore('_ENTRANCETYPE', v);
    }
  },
};

const actions = {
  adultTypeActions({commit}, data){
    commit('SET_adultType', data);
  },
  signImgActions({commit}, data){
    commit('signImgMutation', data);
  },
  enterSchoolImgActions({commit}, data){
    commit('enterSchoolImgMutation', data);
  },
  enterSchoolImgCheckActions({commit}, data){
    commit('enterSchoolImgCheckMutation', data);
  },
  userInfoActions({commit}, data){
    commit('userInfoMutation', data);
  },
  enterConfirmActions({commit}, data){
    commit('enterConfirmMutation', data);
  },
  firstLoginVerifyActions({commit}, data){
    commit('firstLoginVerifyMutation', data);
  },
    //设置入口 成教/自考
    SETENTRANCETYPE({ commit }, v) {
        commit('SET_ENTRANCETYPE', v);
    },
    //设置isGenerateRoutes控制动态路由 避免多次重写
    setIsGenerateRoutes({ commit }, v){
        return new Promise(resolve => {
            commit('SET_isGenerateRoutes', v);
            resolve();
        });
    },
    // 重写路由   
    generateRoutes({ commit }) { 
        return new Promise(resolve => {
            let _ENTRANCETYPE = this.state.permission._ENTRANCETYPE;
            const adultType = this.state.permission.adultType;
            
            // let newRouters = [...constantRoutes, ...asyncRoutes[_ENTRANCETYPE]];
            // for (let i = 0, len = newRouters.length; i < len; i++) {
            //   let item = newRouters[i];
            //   for (let j = i + 1, len = newRouters.length; j < len; j++) {
            //     let item2 = newRouters[j];
            //     if (item.name === item2.name) {
            //         item.children = [...item.children, ...item2.children];
            //         newRouters.splice(j, 1);
            //         j--;
            //         len--; 
            //     }
            //   }
            // }
            let routeType;
            if(_ENTRANCETYPE === 'adult' && adultType){
              routeType = adultType;
            }else{
              routeType = _ENTRANCETYPE;
            }

            let addRouter = asyncRoutes[routeType];
            let newRouters = deepCopy(constantRoutes);
            if(_ENTRANCETYPE === 'academicDegree' || _ENTRANCETYPE === 'graduationProve'){
              newRouters = addRouter;
            }else{
              // 拿出name不相同的数据 并合并在newRouters 并且相同name的数据 children 合并
              for(let item of addRouter){
                for(let item2 of newRouters){
                  if(item.name === item2.name){
                    item2.children = [...item2.children, ...item.children];
                  }
                }
                let isExisName = newRouters.some(item3 => item3.name === item.name);
                if(!isExisName){
                  newRouters.push(item);
                }
              }
              // for(let item of newRouters){
              //     for(let item2 of addRouter){
              //         if(item.name === item2.name){
              //             item.children = [...item.children, ...item2.children];
              //         }
              //     }
              // }
            }
            // console.log(newRouters);
            commit('SET_ROUTES', newRouters);
            commit('SET_isGenerateRoutes', false);
            resolve(newRouters);
        });             
    },
    // 删除路由
    removeRoutes({ commit }){
        commit('SET_isGenerateRoutes', '');
        commit('SET_ROUTES', []);
    },
    // 删除登录相关
    removeLogin({ commit }){
      commit('enterSchoolImgMutation', '');
      commit('enterSchoolImgCheckMutation', 0);
      commit('enterConfirmMutation', 0);
      commit('firstLoginVerifyMutation', 0);
      commit('userInfoMutation', '');
      commit('signImgMutation', '');
      removeStore('token'); 
  },
    // 退出登录 删除数据
    async logOut({dispatch}, v){
      await dispatch('removeRoutes');  //删除路由
      await dispatch('removeLogin');  //删除登录相关
      window.sessionStorage.clear();
      window.localStorage.clear();
    }, 
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
